<div class="flex flex-col">
  @if (loading.skeleton || loading.sync) {
    <div class="flex flex-col gap-2">
      <maximizer-outlook-skeleton-entry></maximizer-outlook-skeleton-entry>
      <maximizer-outlook-skeleton-entry></maximizer-outlook-skeleton-entry>
    </div>
  } @else {
    @if (showSaveNow()) {
      <div class="flex flex-col gap-2">
        {{ 'outlook.compose.saveNowDescription' | translate }}
        <div class="flex justify-end">
          <button
            #saveBtn
            kendoButton
            themeColor="primary"
            [disabled]="noEmailsSelected()"
            [title]="'outlook.compose.saveNow' | translate"
            (click)="saveNow(); saveBtn.blur()"
          >
            {{ 'outlook.compose.saveNow' | translate }}
          </button>
        </div>
      </div>
    } @else if (showSaveOnSend()) {
      <div class="flex gap-1 items-center">
        <kendo-switch
          #switch
          kendoTooltip
          id="outlook-main-ui-compose-saveToEmail-sendSaveToggle"
          [disabled]="
            autoSaveDisabled() || noEmailsSelected() || hasSyncErrors()
          "
          [(ngModel)]="saveToEmailSwitch"
          (valueChange)="handleSwitchValueChanged($event)"
          size="small"
          [tooltipWidth]="275"
          [title]="
            autoSaveDisabled()
              ? ('outlook.compose.autoSave.tooltip.emailSyncDisabled'
                | translate)
              : ('outlook.compose.autoSave.description' | translate)
          "
          [tooltipTemplate]="tooltipTemplate"
        ></kendo-switch>
        <kendo-label for="switch">
          {{ 'outlook.compose.autoSave.title' | translate }}
        </kendo-label>
        @if (hasSyncErrors()) {
          <div
            kendoTooltip
            [title]="
              'outlook.compose.autoSave.tooltip.syncAuthError' | translate
            "
            [tooltipTemplate]="tooltipTemplate"
            [tooltipWidth]="275"
            class="pl-1"
          >
            <span
              class="fa-icons icon-16 icon-solid icon-triangle-exclamation text-warning-100"
            ></span>
          </div>
        }
      </div>
    }

    @if (userRightsToSaveEmail) {
      <div class="flex flex-col mt-2">
        <!-- Save email to entries list -->
        @for (field of saveForEntryList(); track field.localId) {
          @if (field.items.length > 0) {
            <p class="text-neutral-90 subtitle-2 my-0.5">
              {{ field.displayName }}:
            </p>
            @for (entry of field.items; track entry.id) {
              <maximizer-outlook-entry-list-item
                [entryItem]="entry"
                [userEmails]="outlookStore.userEmails()"
                (position)="onEntryPositionChange($event)"
                (selection)="onEntrySelectionChange($event)"
                (openEntry)="openEntryDetail($event)"
              ></maximizer-outlook-entry-list-item>
            }
          }
        }
      </div>
    }

    @if (showSaveOnSendWarning()) {
      <div class="mt-2">
        @if (!outlookStore.versionValidForNewSync()) {
          <maximizer-warning>
            <span class="subtitle-2"
              >{{ 'outlook.compose.outdatedVersion.header' | translate }}:</span
            >
            <p class="mt-1 text-body">
              {{ 'outlook.compose.outdatedVersion.description' | translate }}
            </p>
            <p class="mt-3 text-body whitespace-break-spaces">
              {{ 'outlook.compose.outdatedVersion.phone' | translate }}
            </p>
            <p
              class="mt-3 text-body whitespace-break-spaces"
              [innerHTML]="'outlook.compose.outdatedVersion.email' | translate"
            ></p>
          </maximizer-warning>
        } @else if (
          outlookStore.isSharedMailbox() &&
          outlookStore.isCloud() &&
          isEmailSyncFeatureFlagEnabled
        ) {
          <maximizer-warning
            translationEntry="outlook.compose.forbiddenSharedMailbox"
          />
        } @else if (isOutlookLegacyDesktop()) {
          <maximizer-warning
            translationEntry="outlook.compose.classicUnavailable"
          />
        }
      </div>
    }

    @if (!userRightsToSaveEmail) {
      <maximizer-warning
        translationEntry="outlook.compose.insufficientPermissions"
      />
    }
  }
</div>

@if (saveEmailDetail) {
  <maximizer-email-detail
    [emailProperties]="saveEmailDetailProperties"
    (saveEmail)="onSaveEmailDetail($event)"
    (closed)="this.saveEmailDetail = false"
  ></maximizer-email-detail>
}

<maximizer-outlook-notification #notification [closable]="true">
</maximizer-outlook-notification>

<ng-template #tooltipTemplate let-anchor>
  <p
    class="text-body text-neutral-90"
    [innerHTML]="anchor.nativeElement.getAttribute('data-title')"
  ></p>
</ng-template>
